<template>
  <v-layout
    row
    wrap
  >
    <v-flex
      xs10
      offset-xs1
    >
      <v-alert
        :type="setIcon(type)"
        :icon="icon"
        :value="alert"
        :dismissible="true"
        transition="scale-transition"
        v-model="alert"
      >
        <p
          v-if="title"
          class="title"
          v-html="title"
        >
          -
        </p>
        <p class="subtitle-1" v-html="error">
          -
        </p>
        <p v-if="showVerifyLink">
          <router-link
            class="white--text"
            to="/email/activate"
          >
            &gt; Hier kannst Du dir die Bestätigungsemail erneut zusenden lassen &lt;
          </router-link>
        </p>
      </v-alert>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'Alert',
  props: {
    type: {
      type: String,
      default: ''
    },
    error: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    showVerifyLink: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    icon: 'mdi-alert',
    alert: true,
    color: 'primary'
  }),
  methods: {
    setIcon: function (val) {
      let icon = ''
      switch (val) {
        case 'success':
          icon = 'mdi-approval'
          break
        case 'info':
          icon = 'mdi-information-outline'
          break
        case 'warning':
          icon = 'mdi-alert-outline'
          break
        case 'error':
          icon = 'mdi-alert-octagon'
          break
        default:
          return false
      }
      this.icon = icon
      return val
    }
  }
}
</script>
